import { Box } from '@hub/box'
import { Button } from '@hub/button'
import { SearchMediumIcon } from '@hub/icon'
import { Text } from '@hub/text'
import React from 'react'
import { SearchButtonProps } from './types'

export const SearchButtonLarge: React.FC<SearchButtonProps> = ({
  onClick,
  controlledElementId,
  sx,
}) => (
  <Box role="search" sx={sx}>
    <Button
      leftIcon={<SearchMediumIcon />}
      aria-label="Open Search, you can search stores, brands, products, and more"
      variant="solid"
      colorScheme="smoke"
      aria-controls={controlledElementId}
      sx={{
        borderRadius: '9vh',
        height: '1em',
        // because we're overriding the color we need to reset the other states
        // this is why we're setting it with a decendant selector rather than directly on the text
        '& > span': {
          color: 'quartz',
        },
        '&:hover span': { color: 'inherit' },
        '&:active span': { color: 'inherit' },
      }}
      onClick={onClick}
    >
      <Text
        fontSize="font-sm"
        as="span"
        sx={{
          textTransform: 'none',
          fontWeight: 'normal',
        }}
      >
        Stores, brands, products and more
      </Text>
    </Button>
  </Box>
)
